import logoImage from "@/assets/images/logo.png"
import logoImageDark from "@/assets/images/logo-dark.png"
import { VerifyOtpForm } from "@/components/auth/verify-otp-form"
import { useNavigate, useSearchParams } from "react-router-dom"
import { getReturnUrl, withReturnUrl } from "@/utils/return-url"

/**
 * OTP verification page component
 * Provides email verification form after user registration
 * Redirects to dashboard after successful verification
 */
export function VerifyOtpPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const otpId = searchParams.get('id')

  const handleVerificationSuccess = () => {
    // A user who signed up from a deep-link (e.g. a channel's "link your
    // account" card) finishes here — send them on to what they came for
    // instead of dropping them on the dashboard.
    navigate(getReturnUrl(searchParams) ?? "/app/dashboard", { replace: true })
  }

  const handleBackToSignup = () => {
    navigate(withReturnUrl("/signup", searchParams), { replace: true })
  }

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Background decoration - same as home page */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 lg:w-96 lg:h-96 bg-primary-100 dark:bg-primary-900/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-xl opacity-70" />
        <div className="absolute top-40 right-10 w-72 h-72 lg:w-96 lg:h-96 bg-secondary-100 dark:bg-secondary-900/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-xl opacity-70" />
        <div className="absolute -bottom-8 left-20 w-72 h-72 lg:w-96 lg:h-96 bg-primary-50 dark:bg-primary-950/30 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-xl opacity-70" />
      </div>

      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
        {/* Verification Card - just the card, nothing else */}
        <div className="w-full max-w-md">
          <div className="bg-card shadow-xl rounded-2xl border border-border p-8">
            {/* Logo inside the card */}
            <div className="flex justify-center mb-6">
              <img
                src={logoImage}
                alt="Taqat AI Logo"
                className="h-10 w-auto block dark:hidden"
              />
              <img
                src={logoImageDark}
                alt="Taqat AI Logo"
                className="h-10 w-auto hidden dark:block"
              />
            </div>

            <VerifyOtpForm
              otpId={otpId}
              onSuccess={handleVerificationSuccess}
              onBackToSignup={handleBackToSignup}
            />
          </div>
        </div>
      </div>
    </div>
  )
}